import { Spacing } from '../../../enums/spacing'
import { pxToNumber } from '../../../utils/pxToNumber'

export const TABLE_ROW_HORIZONTAL_SPACING = Spacing.S24
export const TABLE_ROW_VERTICAL_SPACING = Spacing.S16

export const SubRowSpacing = pxToNumber(Spacing.S24)
export const CheckboxSpacing = pxToNumber(Spacing.S16)
export const RowWithCheckboxSpacingLeft = pxToNumber(Spacing.S24) + CheckboxSpacing
